import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { PageLayout } from '@/shared/layout/PageLayout';
import { Button } from '@/components/ui/Button';
import { ZoneInfoForm } from './components/ZoneInfoForm';
import { ZoneBoundaryMap } from './components/ZoneBoundaryMap';
import { useZoneNew } from './hooks/useZoneNew';
import { useAuth } from '@/core/auth/AuthContext';

export default function ZoneNewPage() {
  const navigate = useNavigate();
  const { profile } = useAuth();

  const { 
    formData, 
    handleChange, 
    createZone, 
    isSubmitting,
    projects,
    units,
    parentZones,
    isLoadingProjects,
    isLoadingUnits
  } = useZoneNew();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!profile?.company_id) return;

    try {
      await createZone();
      toast.success('Đã tạo khu vực thành công');
      navigate('/zones');
    } catch (error: any) {
      toast.error(error.message || 'Có lỗi xảy ra khi tạo khu vực');
    }
  };

  return (
    <PageLayout
      title="Tạo khu vực"
      description="Tạo mới khu vực để phục vụ công tác thi công và bảo dưỡng"
    >
      <form onSubmit={handleSubmit} className="max-w-[1600px] mx-auto pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Cột trái: Form thông tin */}
          <div className="lg:col-span-7 space-y-6">
            <ZoneInfoForm 
              formData={formData}
              handleChange={handleChange}
              projects={projects}
              units={units}
              parentZones={parentZones}
              isLoadingProjects={isLoadingProjects}
              isLoadingUnits={isLoadingUnits}
            />
          </div>

          {/* Cột phải: Bản đồ và thông tin ranh giới */}
          <div className="lg:col-span-5 space-y-6">
            <ZoneBoundaryMap />
          </div>
        </div>

        {/* Fixed Bottom Action Bar */}
        <div className="fixed bottom-0 left-0 lg:left-64 right-0 bg-white border-t border-slate-200 p-4 z-40">
          <div className="max-w-[1600px] mx-auto flex items-center justify-end gap-3">
            <Button type="button" variant="outline" onClick={() => navigate('/zones')} className="h-10 px-6 sm:text-sm text-xs">
              Hủy bỏ
            </Button>
            <Button type="submit" disabled={isSubmitting} className="h-10 px-6 sm:text-sm text-xs bg-emerald-800 hover:bg-emerald-900 text-white border-none">
              {isSubmitting ? 'Đang tạo...' : 'Tạo khu vực'}
            </Button>
          </div>
        </div>
      </form>
    </PageLayout>
  );
}
